import React, {FC} from 'react'

import cn from 'classnames/bind'

import {Col, Container, Row} from 'components/elements/grid'
import HowItem from 'components/elements/HowItem/HowItem'
import {Invoice} from 'src/types/__sanitySchema__'

import s from './InvoiceHow.module.scss'
import LandingsTitle from '../../LandingsTitle/LandingsTitle'
const cx = cn.bind(s)

interface IInvoiceHowProps {
	className?: string
	content: Invoice['how']
}

/** InvoiceHow block component */
const InvoiceHow: FC<IInvoiceHowProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} subtitle={content?.description} />

				<Row>
					<Col>
						<div className={cx('list')}>
							{content?.items?.map((item, index) => (
								<HowItem
									className={cx('list__item')}
									key={item._key}
									step={index + 1}
									title={item.title || ''}
									description={item.description || ''}
								/>
							))}
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

InvoiceHow.displayName = 'InvoiceHow'

export default InvoiceHow
